export default __webpack_public_path__ + "static/media/REAL CPI ASSET STIKER-21.f0920c26.png";